import React from 'react';
import { PropTypes } from 'prop-types';
import { Link } from 'react-router-dom';

import AccessControl from 'components/AccessControl';
import ActivityPerms from 'components/AccessControl/permissions.json';

// eslint-disable-next-line import/prefer-default-export
export const BatchFormActionsCellRenderer = ({
  value: id,
  data: batchForm,
  context: {
    settings,
    permissions,
    getOriginalPdfFileCallback,
    editFormAssociationsCallback,
    deleteFormCallback,
    batchItem
  }
}) => (
  <div className="form-action-btn-group">
    {AccessControl.hasPermission(permissions, [ActivityPerms.scannedView, ActivityPerms.scannedEdit, ActivityPerms.scannedValidate])
      && batchForm.hasCustomerAccountLink
      && <Link className="btn btn-sm" to={ `/forms/${ batchForm.formType.toLowerCase() }/${ id }` }><span className="icon icon-apps" /></Link> }
    { (window.navigator && typeof (window.navigator.msSaveOrOpenBlob) !== 'undefined')
      ? AccessControl.hasPermission(permissions, [ActivityPerms.scannedView])
        && <button
          type="button"
          title="View original PDF"
          className="btn btn-sm"
          onClick={ () => getOriginalPdfFileCallback(id) }
        >
          <span className="icon icon-photo" />
        </button>
      : AccessControl.hasPermission(permissions, [ActivityPerms.scannedView])
        && <a
          href={ `/forms/${ batchForm.formType.toLowerCase() }/${ id }/pdf` }
          target="_blank"
          rel="noopener noreferrer"
          className="btn btn-sm"
          title="View original PDF"
        >
          <span className="icon icon-photo" />
        </a> }
    { AccessControl.hasPermission(permissions, [ActivityPerms.fwfBatchReviewer])
      && <button
        className="btn btn-sm"
        onClick={ () => editFormAssociationsCallback(batchForm) }
        type="button"
        title="Edit Form Associations"
      >
        <span className="icon icon-link" />
      </button> }
    { batchItem
      && batchItem.statusString !== 'Completed'
      && AccessControl.hasPermission(permissions, [ActivityPerms.fwfBatchReviewer])
      && <button
        className="btn btn-sm btn-danger"
        onClick={ () => deleteFormCallback(batchForm) }
        type="button"
        title="Delete form"
      >
        <span className="icon icon-delete" />
      </button> }
  </div>
);

BatchFormActionsCellRenderer.propTypes = {
  value: PropTypes.oneOfType([
    PropTypes.number,
    PropTypes.string
  ]).isRequired,
  data: PropTypes.shape({
    formType: PropTypes.string,
    isOnlineForm: PropTypes.bool,
    hasCustomerAccountLink: PropTypes.bool,
    accountId: PropTypes.number
  }).isRequired,
  context: PropTypes.shape({
    batchItem: PropTypes.shape({
      statusString: PropTypes.string
    }),
    permissions: PropTypes.arrayOf(PropTypes.string),
    editCustomerLegalEntitiesCallback: PropTypes.func,
    getOriginalPdfFileCallback: PropTypes.func,
    editFormAssociationsCallback: PropTypes.func,
    deleteFormCallback: PropTypes.func,
    settings: PropTypes.shape()
  })
};

BatchFormActionsCellRenderer.defaultProps = {
  context: {}
};
